<template>
  <div>
    <base-header class="pb-6" type="">
      <div class="row align-items-center py-4">
        <breadcrumbs :header="$t('Edit task')"></breadcrumbs>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col">
          <card type="frame">
            <form-edit-task-type-code></form-edit-task-type-code>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Breadcrumbs from "../../../../../Layout/Breadcrumbs.vue";
  import FormEditTaskTypeCode from "../../../../../Forms/Task/FormEditTaskTypeCode";

  export default {
    name: 'CourseTaskTypeCodeEdit',
    components: {
      FormEditTaskTypeCode,
      Breadcrumbs
    },
  };

</script>

<style scoped>

</style>
